import { createContext, useContext, useState } from "react";
import ModalRenderer from "../Modals/ModalRenderer";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [modal, setModal] = useState({ type: null, props: {} });

  const openModal = (type, props = {}) => setModal({ type, props });

  const closeModal = () => setModal({ type: null, props: {} });

  return (
    <ModalContext.Provider value={{ modal, openModal, closeModal }}>
      {children}
      <ModalRenderer modal={modal} closeModal={closeModal} />
    </ModalContext.Provider>
  );
};

export const useModalContext = () => useContext(ModalContext);
